import { Dialog, makeStyles } from '@material-ui/core';
import { useContext } from 'react';
import MyDataSpacesViewContext from '../my_dataspaces/context/MyDataSpacesViewContext';
import { DataSpaceViewProvider } from '../my_dataspaces/context/DataSpaceViewContext';
import DataSpaceViewNew from '../my_dataspaces/dataspace_view_new/DataSpaceView';
import CreateDataSpaceButton from './CreateDataSpaceButton';
import SelectFantasyLeagueDialog from './SelectFantasyLeagueDialog';
import CommunityDataSpacesContext from '../../context/CommunityDataSpacesContext';

const useStyles = makeStyles(() => ({
	dialog: {
		overflow: 'auto',
		'& .MuiDialog-container': {
			minHeight: '40rem',
			padding: '2rem 0',
		},
		'& .MuiDialog-paper': {
			width: '95%',
			height: '100%',
			maxHeight: '60rem',
			margin: 0,
		},
	},
}));

const DataSpacePreviewDialog = (props) => {
	const classes = useStyles();

	const myDataSpacesViewContext = useContext(MyDataSpacesViewContext);
	const communityDataSpacesContext = useContext(CommunityDataSpacesContext);

	const callToActionButton = communityDataSpacesContext.selectedDataSpace?.datasets.some((dataset) =>
		['Yahoo! Fantasy Sports', 'Fantrax'].includes(dataset.tags.api),
	) ? (
		<SelectFantasyLeagueDialog />
	) : (
		<CreateDataSpaceButton />
	);

	return (
		<Dialog
			open={props.isDataSpacePreviewDialogOpen}
			fullWidth={true}
			maxWidth="lg"
			onClose={() => {
				props.setIsDataSpacePreviewDialogOpen(false);
			}}
			className={classes.dialog}
		>
			<DataSpaceViewProvider>
				{communityDataSpacesContext.selectedDataSpace && (
					<DataSpaceViewNew
						dataSpaceName={
							communityDataSpacesContext.selectedDataSpace?.name ||
							myDataSpacesViewContext.myDataSpacesView.selectedDataSpace.name
						}
						dataSpaceId={
							communityDataSpacesContext.selectedDataSpace?._id ||
							myDataSpacesViewContext.myDataSpacesView.selectedDataSpace.id
						}
						handleDataSpaceLoadingError={() => {}}
						isEditingDisabled={true}
						callToActionButton={callToActionButton}
					/>
				)}
			</DataSpaceViewProvider>
		</Dialog>
	);
};

export default DataSpacePreviewDialog;
